export const searchResultListColumns = {
  SELECT: 'select',
  AUTH_REF_TYPE: 'authRefType',
  HEADING_REF: 'headingRef',
  HEADING_TYPE: 'headingType',
  LINK: 'link',
  NUMBER_OF_TITLES: 'numberOfTitles',
};
